var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 102.4
  }), /*#__PURE__*/React.createElement("rect", {
    y: 204.8,
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 102.4
  })), /*#__PURE__*/React.createElement("rect", {
    y: 102.4,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 102.4
  }), /*#__PURE__*/React.createElement("rect", {
    y: 409.6,
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 102.4
  }), /*#__PURE__*/React.createElement("rect", {
    y: 307.2,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 102.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M301.895,307.2H0V0h309.895v299.2C309.895,303.618,306.313,307.2,301.895,307.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M151.616,72.288l-19.472,58.385l-61.545,0.477c-3.374,0.026-4.773,4.332-2.059,6.336l49.51,36.561  l-18.565,58.68c-1.018,3.217,2.645,5.878,5.39,3.916l50.071-35.789l50.071,35.789c2.745,1.962,6.408-0.699,5.39-3.916l-18.565-58.68  l49.51-36.561c2.714-2.004,1.315-6.31-2.059-6.336l-61.545-0.477l-19.472-58.385C157.211,69.087,152.684,69.087,151.616,72.288z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.2a9d6bc323d5daae6dd05b183de71902.svg";
export { ForwardRef as ReactComponent };